<template>
    <div class="CollectionCarousel">
        <section class="c-section">
            <div class="c-products-row items" @scroll="handleScroll" ref="slider" v-if="collections.length != 0" @mousedown="mousedown" @mouseleave="mouseleave" @mouseup="mouseup" @mousemove="mousemove">
                <div class="row d-flex c-item" v-for="c in collections" :key="c">
                    <div class="col-6">
                        <div class="about-us">
                            <div class="inner" dir="rtl">
                                <router-link @dragstart.prevent :to="'/collection/' + c.slug">
                                    <h4 class="title mt-3">{{c.name}}</h4>
                                    <p>{{c.description}}</p>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 my-2">
                        <div class="about-us-image">
                            <router-link @dragstart.prevent :to="'/collection/' + c.slug">
                                <img v-lazy="$RESIZE + c.image + '&collection=1'" :alt="c.name" />
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="c-products-row" v-if="collections.length == 0">
                <div class="row d-flex c-item2" v-for="c in 5" :key="c">
                    <img src="../assets/collection.webp" class="w-100 h-100">
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
  name: 'CollectionCarousel',
  data () {
    return {
      isDown: false,
      startX: null,
      scrollLeft: null,
      interval: null
    }
  },
  props: {
    collections: Array
  },
  methods: {
    mousedown: function (e) {
      this.isDown = true
      this.$refs.slider.classList.add('active')
      this.startX = e.pageX - this.$refs.slider.offsetLeft
      this.scrollLeft = this.$refs.slider.scrollLeft
    },
    mouseleave: function () {
      this.isDown = false
      try {
        this.$refs.slider.classList.remove('active')
      } catch {}
    },
    mouseup: function () {
      this.isDown = false
      this.$refs.slider.classList.remove('active')
    },
    mousemove: function (e) {
      if (this.isDown) {
        e.preventDefault()
        const x = e.pageX - this.$refs.slider.offsetLeft
        const walk = (x - this.startX) * 2
        this.$refs.slider.scrollLeft = this.scrollLeft - walk
      }
    },
    handleScroll: function () {
      if (this.interval && this.$refs.slider.scrollLeft < -80) {
        clearInterval(this.interval)
        this.interval = null
      }
    }
  },
  unmounted () {
    clearInterval(this.interval)
    this.interval = null
  },
  mounted () {
    if (this.$refs.slider && this.collections.length > 0 && !this.interval) {
      this.interval = setInterval(() => {
        if (this.$refs.slider) {
          this.$refs.slider.style['scroll-behavior'] = 'smooth'
          this.$refs.slider.scrollLeft = this.scrollLeft - 70
          setTimeout(() => {
            if (this.$refs.slider) {
              this.$refs.slider.scrollLeft = this.scrollLeft + 70
              this.$refs.slider.style['scroll-behavior'] = 'auto'
            }
          }, 200)
        }
      }, 10000)
    }
  }
}
</script>

<style scoped>
h4{
    font-weight: 400;
    font-size: 24px;
}
p{
    font-size: 14px;
    font-weight: 300;
    color: #696969;
}
img{
    width: 250px;
    height: 250px;
    border-radius: 24px;
}
.c-item{
    box-shadow: 0 0 8px rgb(0 0 0 / 12%);
    margin-top: 10px!important;
    border-radius: 16px;
    min-width: 550px;
    max-width: 600px;
    height: auto;
    margin-left: 20px;
    margin-right: 5px;
    padding: 10px;
    background: #fff;
}
.c-item2{
    margin-top: 10px!important;
    width: 550px;
    height: auto;
    margin-left: 20px;
    margin-right: 5px;
    padding: 0;
}
.items {
  position: relative;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  transition: all 0.2s;
  transform: scale(0.97);
  will-change: transform;
  user-select: none;
  cursor: pointer;
  scrollbar-width: none;
}

.items.active {
  cursor: grabbing;
  cursor: -webkit-grabbing;
  transform: scale(1);
}

</style>
